import {
  Column,
  Row,
  TextInput,
} from "pages/setting/components/Modal.styled";
import { decrypt } from "shared/lib/crypto/decrypt";
import { ChipGroup } from "shared/ui/filters";

const DEPARTMENT_LABEL = ["총학생회", "총동연", "중선관위", "예심위"];
// 일반 관리자(auth 2)가 선택할 수 있는 소속: 총학생회를 제외한 산하 자치기구.
// DEPARTMENT_LABEL 인덱스를 그대로 사용해 값 매핑 일관성을 유지한다.
const GENERAL_MANAGER_DEPARTMENT_INDEXES = [1, 2, 3];

export const ProfileForm = ({
  userInfo,
  name,
  onChangeName,
  departmentBtnClicked,
  handleDepartmentBtnClick,
  position,
  onChangePosition,
}) => {
  // 총학 관리자(3)·마스터(4)는 소속이 '총학생회'로 고정.
  // 칩은 그대로 노출하되 전부 disabled 처리해 선택만 잠근다.
  const isCouncilLevel = Number(userInfo?.auth) >= 3;
  const departmentOptions = isCouncilLevel
    ? DEPARTMENT_LABEL.map((label, index) => ({
        label,
        value: index,
        disabled: true,
      }))
    : GENERAL_MANAGER_DEPARTMENT_INDEXES.map((index) => ({
        label: DEPARTMENT_LABEL[index],
        value: index,
      }));

  return (
    <Column style={{ flexGrow: "1" }}>
      {/* 이름 */}
      <Row>
        <RowTitle rowName="이름" essential={true} />
        <TextInput value={name} onChange={onChangeName} type="text" />
      </Row>

      {/* 이메일 */}
      <Row style={{ marginTop: "22px" }}>
        <RowTitle rowName="이메일" essential={false} />
        {userInfo?.email && <span>{decrypt(userInfo?.email)}</span>}
      </Row>

      {/* 소속 */}
      <Row style={{ marginTop: "22px" }}>
        <RowTitle rowName="소속" essential={true} />
        <ChipGroup
          options={departmentOptions}
          value={departmentBtnClicked.findIndex(Boolean)}
          onChange={handleDepartmentBtnClick}
          allowDeselect={false}
        />
      </Row>

      {/* 직책 */}
      <Row style={{ marginTop: "22px" }}>
        <RowTitle rowName="직책" essential={true} />
        <TextInput value={position} onChange={onChangePosition} type="text" />
      </Row>
    </Column>
  );
};

// Row 별 타이틀 (이름, 필수 여부)
const RowTitle = ({ rowName, essential }) => {
  return (
    <span style={{ width: "100px" }}>
      {rowName}
      {essential && <span style={{ color: "red" }}>*</span>}
    </span>
  );
};
